import React from 'react'

import { Fieldset, Subsection } from '@fourthwall/components'

import { ShippingStartDate } from '../shared/ShippingStartDate/ShippingStartDate'
import { ShipmentWeightField } from '../shared/ShippingWeight/ShipmentWeightField'
import { TaxFields } from '../shared/TaxFields'
import * as S from './styled'

export const ProductShippingNotConfigurable = () => (
  <Subsection title="Shipping">
    <S.Container>
      <p>
        This product is produced to order. During checkout, supporters pay the cost of shipping,
        based on the weight of their order.
      </p>
    </S.Container>
    {/* TODO:
         ProductShippingNotConfigurable shouldn't have neither ShipmentWeightField or ShipmentStartDateFields
         these should be removed after Shipping module refactor is done. */}
    <Fieldset>
      <ShipmentWeightField />
      <ShippingStartDate />
      <TaxFields showLearnMoreLinks />
    </Fieldset>
  </Subsection>
)
